import { Component } from '@angular/core';
import { Mode, NumberFieldComponent } from './number-field.component';

@Component( {
    selector: 'erp-pbw-gehaltswunsch',
    templateUrl: './number-field.component.html'
} )
export class SalaryRequirementsFormComponent extends NumberFieldComponent {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.salaryRequirements',
            { min: 0, maxFractionDigits: 0, mode: Mode.CURRENCY } );
    }

    set value( t: number | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.salaryRequirements = t;
        }
    }

    get value(): number | undefined {
        return this.jobapplication?.salaryRequirements;
    }
}
